var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferfromto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.343,
    height: 76.108,
    viewBox: "0 0 174.343 76.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-transfer",
    transform: "translate(0 -21.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9453",
    "data-name": "Group 9453",
    transform: "translate(0 21.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11120",
    "data-name": "Path 11120",
    d: "M84.805,90.734C60.562,80.355,52.912,34.761,77.3,21.551a32.819,32.819,0,0,1,29.186,31.515C106.993,69.718,94.491,82.992,84.805,90.734Z",
    transform: "translate(-41.139 -21.365)",
    fill: "#d68080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M43.666,90.374a90.411,90.411,0,0,1-8.482,6.02,4.733,4.733,0,0,1-5.013,0C22.521,91.616,0,75.683,0,53.688a32.678,32.678,0,0,1,36.16-32.5C24.089,40.881,25.046,70.249,43.666,90.374Z",
    transform: "translate(0 -21.005)",
    fill: "#bc2323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11122",
    "data-name": "Path 11122",
    d: "M96.968,85.049a16.491,16.491,0,0,1-16.491,16.487q-.595,0-1.179-.042c-7.654-7.809-9.668-23.534-1.88-32.652a16.5,16.5,0,0,1,19.55,16.207Z",
    transform: "translate(-47.797 -52.365)",
    fill: "#f3f5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11123",
    "data-name": "Path 11123",
    d: "M62.862,102.044a16.491,16.491,0,0,1-1.88-32.652A59.73,59.73,0,0,0,62.862,102.044Z",
    transform: "translate(-31.361 -52.915)",
    fill: "#d7ddf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9454",
    "data-name": "Group 9454",
    transform: "translate(108.982 21.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11124",
    "data-name": "Path 11124",
    d: "M404.858,90.734c-24.244-10.379-31.893-55.973-7.507-69.183a32.819,32.819,0,0,1,29.186,31.515C427.046,69.718,414.544,82.992,404.858,90.734Z",
    transform: "translate(-361.191 -21.365)",
    fill: "#9fc7d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11125",
    "data-name": "Path 11125",
    d: "M363.719,90.374a90.405,90.405,0,0,1-8.482,6.02,4.733,4.733,0,0,1-5.013,0c-7.651-4.778-30.172-20.711-30.172-42.706a32.677,32.677,0,0,1,36.16-32.5C344.142,40.881,345.1,70.249,363.719,90.374Z",
    transform: "translate(-320.053 -21.005)",
    fill: "#458cd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11126",
    "data-name": "Path 11126",
    d: "M417.021,85.049a16.491,16.491,0,0,1-16.491,16.487q-.595,0-1.179-.042c-7.654-7.809-9.668-23.534-1.88-32.652a16.5,16.5,0,0,1,19.55,16.207Z",
    transform: "translate(-367.85 -52.365)",
    fill: "#f3f5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127",
    "data-name": "Path 11127",
    d: "M382.915,102.044a16.491,16.491,0,0,1-1.88-32.652A59.729,59.729,0,0,0,382.915,102.044Z",
    transform: "translate(-351.414 -52.915)",
    fill: "#d7ddf5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11134",
    "data-name": "Path 11134",
    d: "M235.3,181.238l-10.013-7.766a3.146,3.146,0,0,0-5.074,2.486,1.84,1.84,0,0,1-1.84,1.84H201.161a4.256,4.256,0,0,0-4.256,4.256v5.921a4.256,4.256,0,0,0,4.256,4.256h17.213a1.84,1.84,0,0,1,1.84,1.84,3.146,3.146,0,0,0,5.074,2.486l10.013-7.766A4.78,4.78,0,0,0,235.3,181.238Z",
    transform: "translate(-129.856 -100.111)",
    fill: "#bd9cde"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferfromto);
export default __webpack_public_path__ + "static/media/transferfromto.307b7bb43be6e0c76dba96c48d83a9d4.svg";
export { ForwardRef as ReactComponent };